import * as React from 'react';
import { SVGProps } from 'react';
const SvgMobile = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 2H5V21.9989H19.0005L19 2.00117V2ZM7.00055 19.9997V3.99968H17.0005L17.0025 19.9997H7.00055Z"
      fill="current"
    />
    <path
      d="M12.0005 18.9997C12.5528 18.9997 13.0005 18.552 13.0005 17.9997C13.0005 17.4474 12.5528 16.9997 12.0005 16.9997C11.4483 16.9997 11.0005 17.4474 11.0005 17.9997C11.0005 18.552 11.4483 18.9997 12.0005 18.9997Z"
      fill="current"
    />
  </svg>
);
export default SvgMobile;
